module.exports = __webpack_public_path__ + "static/media/sanofi_logo.923bc661.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sanofi_logo.jpg
// module id = 1857
// module chunks = 0